<template>
    <div>
        <div class="row mt-2" v-for="(data, index) in dates">
            <div class="col-12">
                <el-date-picker
                    v-model="dates[index]"
                    type="datetimerange"
                    :picker-options="datesOptions"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    clear-icon=""
                    size="mini"
                    style="width: calc(100% - 3.5rem) !important;">
                </el-date-picker>
                <base-button
                    size="sm"
                    icon
                    type="danger"
                    style=""
                    class="ml-2"
                    @click.native="dates.splice(index,1)
                        ">
                    <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
                </base-button>
            </div>


        </div>
        <div class="row">
            <div class="col-12">
                <base-button
                    size="sm"
                    icon
                    type="success"
                    @click="addDates"
                >
                    <font-awesome-icon :icon="['fal','plus']"></font-awesome-icon>
                </base-button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "TimeconditionDates",
        props: {
            initialValue: Array,
        },
        data() {
            return {
                dates: this.initialValue,
                datesOptions: {
                    shortcuts: [
                        {
                            text: 'Christmas',
                            onClick(picker) {
                                const start = new Date(new Date().getFullYear(), 11, 25, 0, 0);
                                const end = new Date(new Date().getFullYear(), 11, 25, 23, 59);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Purim 2019',
                            onClick(picker) {
                                const start = new Date(2019, 2, 20, 18, 0);
                                const end = new Date(2019, 2, 21, 18, 0);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: 'New Years',
                            onClick(picker) {
                                const start = new Date(new Date().getFullYear() + 1, 0, 1, 0, 0);
                                const end = new Date(new Date().getFullYear() + 1, 0, 1, 23, 59);
                                picker.$emit('pick', [start, end]);
                            }
                        }]
                },
            }
        },
        methods: {
            addDates() {
                let date = new Date();
                date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getUTCDay() + ' ' + date.getUTCHours() + ':00';
                this.dates.push([date, date]);
            }
        },
        mounted() {
            if (this.initialValue === undefined) {
                this.dates = [];
            } else {
                this.dates = this.initialValue;

            }
        },
        watch: {
            times: {
                handler(value) {
                    this.$emit('update', this.dates);
                },
                deep: true
            }, initialValue: {
                handler(value) {
                    this.dates = this.initialValue;
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>
